import React, { Component } from 'react'
import config from './config'

// import App from 'base-shell/lib'
import App from './containers/App/App'

export default class Demo extends Component {
  render() {

    if (process.env.NODE_ENV === "production")  console.log = function no_console() {}

    return <App config={config} />
  }
}
